import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

import { GridSortItem } from "@mui/x-data-grid";

import { RootState } from "App/Store";

import { SortOrderType } from "Common/Enums";

import { ISortByParams } from "Types/EVaultAppTypes";

import { fetchArchivedLoans, updateSearchBarParams, updateSortBy } from "./ArchivedSlice";
import { IArchivedLoansSearchApiParams } from "./Types";
import { getTransferredMERSPackagesUrl } from "./archivedLoansAdapter";

export function executeSearch(): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    const state: RootState = getState();
    const data = state.archivedLoans.searchBarParams.data;
    const searchParams = {
      ...data,
      searchTerm: data.searchTerm?.trim(),
    };
    dispatch(updateSearchBarParams(searchParams));
    await dispatch(fetchArchivedLoansAction());
  };
}

export function updateSortByAction({ field, sort }: GridSortItem): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    // Return if missing necessary arguments
    if (!field || !sort) return;

    const { sortField: prevSortField, sortOrderType: prevSortOrderType } = getState().archivedLoans.sortByParams;
    const newSortOrderType = sort === "asc" ? SortOrderType.ASCENDING : SortOrderType.DESCENDING;

    // If no sort property changes, exit without fetching new data
    if (prevSortField === field && prevSortOrderType === newSortOrderType) return;

    const newSortOrderParams: ISortByParams = {
      sortField: field,
      sortOrderType: newSortOrderType,
    };
    dispatch(updateSortBy(newSortOrderParams));
    dispatch(fetchArchivedLoansAction());
  };
}

export function fetchArchivedLoansAction(resourceUrl?: string): ThunkAction<void, RootState, unknown, AnyAction> {
  return async (dispatch, getState) => {
    const state: RootState = getState();
    if (resourceUrl) {
      dispatch(fetchArchivedLoans(resourceUrl));
    } else {
      const searchCriteria = state.archivedLoans.searchBarParams.data;
      const sortByParams = state.archivedLoans.sortByParams;
      const params: IArchivedLoansSearchApiParams = {
        ...searchCriteria,
        limit: 100,
        offset: 0,
        sortByParams,
      };
      const url = getTransferredMERSPackagesUrl(params);
      dispatch(fetchArchivedLoans(url));
    }
  };
}
